/**
 * Wire contract for desktop/mobile device annotations, shared by the applier
 * (`apply.ts`) and the email editor (`.../email-editor/device-groups.ts`) so
 * the two can't drift. Dependency-free on purpose: bundled into the frontend.
 */

export const DEVICE_GROUP_ATTR = "data-ht-group";
export const DEVICE_ATTR = "data-ht-device";

export type GroupedDevice = "desktop" | "mobile";

/** One-sided hides: hidden on one form factor, no counterpart, no group id. */
export type OneSidedDevice = "desktop-only" | "mobile-only";

export const ONE_SIDED_DEVICES: readonly OneSidedDevice[] = [
  "desktop-only",
  "mobile-only",
];

export type DeviceKind = GroupedDevice | OneSidedDevice;

// Pairing compares group ids as opaque strings, so an id outside this format
// still links its group — but only `g_<n>` ids advance the mint sequence.
const GROUP_ID_PATTERN = /^g_(\d+)$/;

export function formatGroupId(n: number): string {
  return `g_${n}`;
}

export function parseGroupIdNumber(id: string): number | null {
  const match = GROUP_ID_PATTERN.exec(id);
  return match?.[1] ? Number(match[1]) : null;
}
